export default "__VITE_ASSET__OE32JFxy__"